module.exports = {
      id: "icon-playstore-usage",
      viewBox: "0 0 190.654 62.305",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#icon-playstore",
      toString: function () {
        return this.url;
      }
    }